// extracted by mini-css-extract-plugin
export var aggregationCell = "_2g-h";
export var aggregationRow = "_2g-g";
export var borderlessSpinnerContainer = "_2g-2";
export var closeIcon = "_2g-9";
export var expandIcon = "_2g-a";
export var expanded = "_2g-b";
export var filterDropdown = "_2g-c";
export var filterDropdownDivider = "_2g-7";
export var filterDropdownHeader = "_2g-f";
export var filterDropdownItem = "_2g-e";
export var filterDropdownModal = "_2g-d _2g-c";
export var filterItem = "_2g-6";
export var normalCellWithAdjustableBorder = "_2g-8";
export var pinButtonContainer = "_2g-i";
export var pinIcon = "_2g-j";
export var pinIconActive = "_2g-k";
export var spinner = "_2g-0";
export var spinnerContainer = "_2g-1";
export var tableContainer = "_2g-3";
export var tableContentInner = "_2g-5";
export var tableContentWrapper = "_2g-4";
export var viewButtonContainer = "_2g-l";